import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { AVAILABLE_LANGUAGES, getLanguageDetails } from '../config/languages';
import { useLanguage } from '../contexts/LanguageContext';
import useMobile from '../hooks/useMobile';

const LanguageSelector: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { currentLanguage, setLanguage } = useLanguage();
  const isMobile = useMobile();

  const currentLangDetails = getLanguageDetails(currentLanguage);

  const handleLanguageChange = (langCode: string) => {
    setLanguage(langCode);
    setIsOpen(false);
  };

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center hover:text-pink-200 transition-colors duration-200 bg-white/10 rounded-lg px-3 py-2 backdrop-blur-sm"
      >
        <span className="mr-2">{currentLangDetails?.flag}</span>
        <span className="hidden sm:inline text-sm font-medium">
          {currentLangDetails?.name}
        </span>
        <ChevronDown 
          className={`ml-2 h-4 w-4 transition-transform duration-200 ${
            isOpen ? 'rotate-180' : ''
          }`} 
        />
      </button>

      {isOpen && (
        <>
          {/* Overlay per chiudere il dropdown */}
          <div 
            className="fixed inset-0 z-40" 
            onClick={() => setIsOpen(false)}
          />
          
          {/* Dropdown menu */}
          <div className={`absolute w-48 bg-white rounded-lg shadow-lg border border-gray-200 z-50 overflow-hidden ${
            isMobile 
              ? 'left-0 -mt-2' 
              : 'top-full right-0 mt-2'
          }`} style={isMobile ? { top: '-200%' } : {}}>
            <div className="py-1">
              {AVAILABLE_LANGUAGES.map((language) => (
                <button
                  key={language.code}
                  onClick={() => handleLanguageChange(language.code)}
                  className={`w-full text-left px-4 py-3 text-sm hover:bg-gray-50 transition-colors flex items-center ${
                    currentLanguage === language.code 
                      ? 'bg-pink-50 text-pink-600 font-medium' 
                      : 'text-gray-700'
                  }`}
                >
                  <span className="mr-3 text-lg">{language.flag}</span>
                  <span>{language.name}</span>
                  {currentLanguage === language.code && (
                    <span className="ml-auto text-pink-500">✓</span>
                  )}
                </button>
              ))}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default LanguageSelector;